export const lang = {
    hello:"你好",
    example:'示例',
    httpGET:'HTTP GET',
    httpPOST:'HTTP POST',
    httpDELETE:'HTTP DELETE',
    httpPUT:'HTTP PUT',
};